import React from 'react';
import { render } from 'react-dom';

// for async and await
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'datocms-plugins-sdk/dist/sdk.css';
import './Style.css';

import Main from './Main';
import DatoCmsPlugin from 'datocms-plugins-sdk';
import 'react-dropdown/style.css';
import { DatoApiFacadeProvider } from '@polestar/content-plugin-core';

String.prototype.toCamelCase = function () {
  return this.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace('-', '').replace('_', '');
  });
};

String.prototype.toSnakeCase = function () {
  return this.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

DatoCmsPlugin.init(async (plugin) => {
  plugin.startAutoResizer();

  render(
    <DatoApiFacadeProvider plugin={plugin}>
      <Main plugin={plugin} />
    </DatoApiFacadeProvider>,
    document.getElementById('root')
  );
});
